<template>
    <div>
        <div class="qq-config-open-detail">
            <v-tip ref="qrcode" placement="top" kind="large" clazz="qrcode-poper-wrapper">
                <template slot-scope="props">
                    <QrcodePoper v-if="props.data" :img="props.data.qrUrl" />
                </template>
            </v-tip>
            <div class="open-detail-left-block">
                <v-tabs v-model="selectComponent" kind="line" align="center">
                    <v-tab value="pc">电脑端资料卡</v-tab>
                    <v-tab value="mobile">移动端资料卡</v-tab>
                </v-tabs>
                <div v-if="selectComponent === 'pc'" class="pc-data-block">
                    <div class="pc-data-block-left">
                        <div class="pc-data-block-left__logo-line">
                            <img :src="companyLogo" alt="logo" class="logo-line-logo-img" />
                        </div>
                        <div class="pc-data-block-left__company-name ellipsis">
                            {{ initData.companyName }}
                        </div>
                        <div v-if="initData.isSelectCompanySignature" class="pc-data-block-left__company-sign ellipsis">
                            {{ initData.companySignature }}
                        </div>
                    </div>
                    <div class="pc-data-block-right">
                        <div
                            v-if="initData.isSelectCompanyAddress && initData.companyAddress"
                            class="icon-detail-line ellipsis"
                        >
                            {{ initData.companyAddress }}
                            <span class="icon position-icon"></span>
                        </div>
                        <div
                            v-if="initData.isSelectCompanyEmail && initData.companyEmail"
                            class="icon-detail-line ellipsis"
                        >
                            {{ initData.companyEmail }}
                            <span class="icon email-icon"></span>
                        </div>
                        <div
                            v-if="initData.isSelectCompanySite && initData.companySite"
                            class="icon-detail-line ellipsis"
                        >
                            {{ initData.companySite }}
                            <span class="icon site-icon"></span>
                        </div>
                        <div
                            v-if="initData.isSelectCompanyPhone && initData.companyPhone"
                            class="icon-detail-line ellipsis"
                        >
                            {{ initData.companyPhone }}
                            <span class="icon phone-icon"></span>
                        </div>
                        <div
                            v-if="initData.isSelectCompanyIntro && initData.companyIntro"
                            class="icon-detail-line ellipsis"
                        >
                            {{ initData.companyIntro }}
                            <span class="icon intro-icon"></span>
                        </div>
                        <div v-if="initData.companyShowCase === 1" class="company-showcase-block">
                            <div class="showcase-block-title">企业推荐</div>
                            <div v-if="!isOnlyOneImg" class="showcase-img-block">
                                <div class="showcase-img-bg">
                                    <div
                                        v-for="(item, idx) in initData.companyShowCaseImg"
                                        :key="idx"
                                        class="showcase-img-item"
                                    >
                                        <img :src="item.image" alt="企业推荐" class="showcase-image" />
                                    </div>
                                </div>
                            </div>
                            <div v-else class="only-one-showcase-img-item">
                                <img
                                    :src="initData.companyShowCaseImg[0].image"
                                    alt="企业推荐"
                                    class="only-one-showcase-image"
                                />
                            </div>
                        </div>
                        <div v-if="isRecommendList" class="recommend-list-block">
                            <div class="recommend-list-title">相关推荐</div>
                            <div v-for="item in initData.recommendation" :key="item.key" class="recommend-list-item">
                                <div class="recommend-list-item-logo">
                                    <img :src="item.logo" alt="logo" class="logo-img" />
                                </div>
                                <div class="recommend-list-item-text">
                                    <div class="left-recommend-name ellipsis">{{ item.name }}</div>
                                    <span
                                        v-tip:qrcode="item"
                                        v-if="item.type != '企业群'"
                                        class="recommend-name-qrcode"
                                    />
                                    <div class="left-recommend-type ellipsis">{{ item.type }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="recommend-none-list">
                            相关推荐
                        </div>
                    </div>
                </div>
                <div v-if="selectComponent === 'mobile'" class="mobile-data-block">
                    <div class="mobile-data-bg">
                        <div class="mobile-data-logo">
                            <img :src="companyLogo" alt="logo" class="mobile-data-logo__image" />
                        </div>
                        <div class="mobile-data-company-line mobile-data-company-name ellipsis">
                            {{ initData.companyName }}
                        </div>
                        <div
                            v-if="initData.isSelectCompanySignature"
                            class="mobile-data-company-line mobile-data-company-sign ellipsis"
                        >
                            {{ initData.companySignature }}
                        </div>
                        <div class="mobile-data-detail-block">
                            <div
                                v-if="initData.isSelectCompanyAddress && initData.companyAddress"
                                class="mobile-icon-detail-line ellipsis"
                            >
                                {{ initData.companyAddress }}
                                <span class="mobile-icon position-icon"></span>
                            </div>
                            <div
                                v-if="initData.isSelectCompanyEmail && initData.companyEmail"
                                class="mobile-icon-detail-line ellipsis"
                            >
                                {{ initData.companyEmail }}
                                <span class="mobile-icon email-icon"></span>
                            </div>
                            <div
                                v-if="initData.isSelectCompanySite && initData.companySite"
                                class="mobile-icon-detail-line ellipsis"
                            >
                                {{ initData.companySite }}
                                <span class="mobile-icon site-icon"></span>
                            </div>
                            <div
                                v-if="initData.isSelectCompanyPhone && initData.companyPhone"
                                class="mobile-icon-detail-line ellipsis"
                            >
                                {{ initData.companyPhone }}
                                <span class="mobile-icon phone-icon"></span>
                            </div>
                            <div
                                v-if="initData.isSelectCompanyIntro && initData.companyIntro"
                                class="mobile-icon-detail-line ellipsis"
                            >
                                {{ initData.companyIntro }}
                                <span class="mobile-icon intro-icon"></span>
                            </div>
                        </div>
                        <div v-if="initData.companyShowCase === 1" class="mobile-recommend-list-block">
                            <div v-if="isOnlyOneImg">
                                <div class="mobile-recommend-list-title">企业推荐</div>
                                <div class="mobile-showcase-only-img-block">
                                    <img
                                        :src="initData.companyShowCaseImg[0].image"
                                        class="mobile-showcase-img-item"
                                        alt="image"
                                    />
                                </div>
                            </div>
                            <div v-else class="mobile-showcase-img-block">
                                <div class="mobile-recommend-list-title">企业推荐</div>
                                <div class="mobile-showcase-img-bg">
                                    <div
                                        v-for="(item, idx) in initData.companyShowCaseImg"
                                        :key="idx"
                                        class="mobile-showcase-img-item"
                                    >
                                        <img :src="item.image" alt="企业推荐" class="showcase-image" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isRecommendList" class="mobile-recommend-list-block">
                            <div class="mobile-recommend-list-title">相关推荐</div>
                            <div class="mobile-list-wrapper">
                                <div class="mobile-list">
                                    <div
                                        v-for="item in initData.recommendation"
                                        :key="item.key"
                                        class="mobile-recommend-list-item"
                                    >
                                        <img :src="item.logo" alt="logo" class="mobile-logo-img" />
                                        <div class="mobile-recommend-list-item-text">
                                            <div class="mobile-recommend-type ellipsis">{{ item.type }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="mobile-recommend-none-list">
                            相关推荐
                        </div>
                    </div>
                </div>
            </div>
            <div class="open-detail-right-block">
                <div class="open-detail-right-block__basic-info">
                    <div class="basic-title">企业主号对外资料展示</div>
                    <div class="sub-title">
                        基础资料 <a href="/mng/account/corpInfo" target="_blank" class="change-basic">修改</a>
                    </div>
                    <div class="checkbox-line">
                        <v-checkbox v-model="initData.isSelectCompanySignature" label="企业签名"></v-checkbox>
                        <div class="checkbox-desc">
                            {{ initData.companySignature }}
                            <div v-if="initData.isSelectCompanySignature && initData.companySignature == ''">
                                <v-icon v-tip:hint.hover.delay name="input_question" class="question-mark"></v-icon>
                            </div>
                        </div>
                    </div>
                    <div class="checkbox-line">
                        <v-checkbox v-model="initData.isSelectCompanyAddress" label="企业地址"></v-checkbox>
                        <div class="checkbox-desc">
                            {{ initData.companyAddress }}
                            <div v-if="initData.isSelectCompanyAddress && initData.companyAddress == ''">
                                <v-icon v-tip:hint.hover.delay name="input_question" class="question-mark"></v-icon>
                            </div>
                        </div>
                    </div>
                    <div class="checkbox-line">
                        <v-checkbox v-model="initData.isSelectCompanyEmail" label="电子邮箱"></v-checkbox>
                        <div class="checkbox-desc">
                            {{ initData.companyEmail }}
                            <div v-if="initData.isSelectCompanyEmail && initData.companyEmail == ''">
                                <v-icon v-tip:hint.hover.delay name="input_question" class="question-mark"></v-icon>
                            </div>
                        </div>
                    </div>
                    <div class="checkbox-line">
                        <v-checkbox v-model="initData.isSelectCompanySite" label="企业主页"></v-checkbox>
                        <div class="checkbox-desc">
                            {{ initData.companySite }}
                            <div v-if="initData.isSelectCompanySite && initData.companySite == ''">
                                <v-icon v-tip:hint.hover.delay name="input_question" class="question-mark"></v-icon>
                            </div>
                        </div>
                    </div>
                    <div class="checkbox-line">
                        <v-checkbox v-model="initData.isSelectCompanyPhone" label="联系电话"></v-checkbox>
                        <div class="checkbox-desc">
                            {{ initData.companyPhone }}
                            <div v-if="initData.isSelectCompanyPhone && initData.companyPhone == ''">
                                <v-icon v-tip:hint.hover.delay name="input_question" class="question-mark"></v-icon>
                            </div>
                        </div>
                    </div>
                    <div class="checkbox-line">
                        <v-checkbox v-model="initData.isSelectCompanyIntro" label="企业简介"></v-checkbox>
                        <div v-if="initData.isSelectCompanyIntro && initData.companyIntro == ''" class="introduction">
                            <v-icon v-tip:hint.hover.delay name="input_question" class="question-mark"></v-icon>
                        </div>
                        <div v-tip:companyIntroBlock.hover v-else ref="companyIntro" class="checkbox-desc">
                            {{ initData.companyIntro }}
                        </div>
                        <v-tip
                            ref="companyIntroBlock"
                            kind="large"
                            placement="top"
                            :disabled="disabledIntro"
                            clazz="checkbox-desc-block"
                        >
                            {{ initData.companyIntro }}
                        </v-tip>
                    </div>
                    <v-tip ref="hint" placement="top" :gap="10" kind="small" clazz="question-hint">
                        <span>资料为空，请点击“修改”前往填写</span>
                    </v-tip>
                </div>
                <div class="open-detail-right-block__recommendation-block">
                    <div class="company-showcase">
                        <div>
                            企业橱窗<a href="/mng/account/CorpShowWindow" target="_blank" class="change-text">修改</a>
                        </div>
                        <div class="company-showcase__radio">
                            <v-radio-group v-model="initData.companyShowCase">
                                <v-radio name="showcase" :value="1" class="conversation-radio">展示</v-radio>
                                <v-radio name="showcase" :value="2" class="conversation-radio">不展示</v-radio>
                            </v-radio-group>
                        </div>
                    </div>
                    <div class="sub-title">
                        相关推荐
                        <span class="desc-content">
                            推荐<a href="/cl/GroupMng" target="_blank" class="change-basic">企业群</a
                            >，访客可点击直接申请进群
                        </span>
                    </div>
                    <div class="recommendation-block">
                        <v-popper ref="selectRecommend" placement="bottom" @visibleChange="visibleChange">
                            <search-tree-component
                                ref="treeSelect"
                                :select-data="recommendationData"
                                :is-single="false"
                                :tree="false"
                                placeholder="搜索已绑定企业群"
                                max-select="6"
                                :list-function="listFunction"
                                @handleSave="updateRecommendList"
                            />
                        </v-popper>
                        <div v-if="initData.recommendation.length === 0" class="none-recommend">
                            <div class="add-button-line">
                                <span v-popper:selectRecommend.click class="link-text">
                                    <v-icon name="add"></v-icon>添加
                                </span>
                            </div>
                        </div>
                        <div v-else class="recommend-list">
                            <div v-for="item in initData.recommendation" :key="item.key" class="recommend-item">
                                <div class="recommend-item__left">
                                    <img :src="item.logo" alt="推荐logo" class="recommend-item__left-img" />
                                </div>
                                <div class="recommend-item__right">
                                    <template>
                                        <div class="recommend-name">
                                            {{ item.name }}
                                        </div>
                                        <div
                                            v-tip:qrcode="item"
                                            v-if="item.type != '企业群'"
                                            class="recommend-qr-code"
                                        ></div>
                                    </template>
                                    <div class="recommend-type">{{ item.type }}</div>
                                </div>
                            </div>
                            <div class="recommend-list-button-row">
                                <span v-popper:selectRecommend.click icon="v-edit" class="recommend-change-button">
                                    修改
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="qq-config-conversation">
            <div class="qq-config-conversation-right">
                <div class="qq-config-conversation-right__radio-block">
                    <div class="radio-title">左侧对外名称</div>
                    <div class="qq-config-conversation-right__radio">
                        <v-radio-group v-model="initData.leftName">
                            <v-radio name="conversation-name" :value="1" class="conversation-radio">
                                企业简称
                            </v-radio>
                            <v-radio name="conversation-name" :value="2" class="conversation-radio">
                                员工名称
                            </v-radio>
                        </v-radio-group>
                        <StaffChangeInfoComment v-if="initData.leftName == 2"
                            >接入后展示员工对外昵称<br />员工可在【客户端-对外资料】中修改
                        </StaffChangeInfoComment>
                    </div>
                </div>
            </div>
            <div class="qq-config-conversation-left">
                <div>会话窗口</div>
                <div class="qq-config-conversation-left__company-block">
                    <div class="pc-show-block">
                        <div class="pc-show-block-right">
                            <div class="logo-img-line">
                                <img :src="companyLogo" alt="logo" class="pc-show-logo-img" />
                            </div>
                            <div class="company-name-line">
                                {{ initData.companyName }}
                            </div>
                            <div
                                v-if="initData.isSelectCompanySignature && initData.companySignature"
                                class="company-sign-line ellipsis"
                            >
                                {{ initData.companySignature }}
                            </div>
                            <div
                                v-if="initData.isSelectCompanyAddress && initData.companyAddress"
                                class="pc-show-icon-detail-line ellipsis"
                            >
                                {{ initData.companyAddress }}
                                <span class="icon position-icon"></span>
                            </div>
                            <div
                                v-if="initData.isSelectCompanyEmail && initData.companyEmail"
                                class="pc-show-icon-detail-line ellipsis"
                            >
                                {{ initData.companyEmail }}
                                <span class="icon email-icon"></span>
                            </div>
                            <div
                                v-if="initData.isSelectCompanySite && initData.companySite"
                                class="pc-show-icon-detail-line ellipsis"
                            >
                                {{ initData.companySite }}
                                <span class="icon site-icon"></span>
                            </div>
                            <div
                                v-if="initData.isSelectCompanyPhone && initData.companyPhone"
                                class="pc-show-icon-detail-line ellipsis"
                            >
                                {{ initData.companyPhone }}
                                <span class="icon phone-icon"></span>
                            </div>
                            <div
                                v-if="initData.isSelectCompanyIntro && initData.companyIntro"
                                class="pc-show-icon-detail-line ellipsis"
                            >
                                {{ initData.companyIntro }}
                                <span class="icon intro-icon"></span>
                            </div>
                            <div v-if="isRecommendList" class="pc-show-recommend-list-block">
                                <div class="pc-show-recommend-list-title">相关推荐</div>
                                <div class="list-wrapper">
                                    <div
                                        v-for="item in initData.recommendation"
                                        :key="item.key"
                                        class="pc-show-recommend-list-item"
                                    >
                                        <div class="pc-show-recommend-list-item-logo">
                                            <img :src="item.logo" alt="logo" class="pc-show-logo-img" />
                                        </div>
                                        <div class="pc-show-recommend-list-item-text">
                                            <div class="pc-show-recommend-name ellipsis">{{ item.name }}</div>
                                            <span
                                                v-tip:qrcode="item"
                                                v-if="item.type != '企业群'"
                                                class="pc-show-recommend-name-qrcode"
                                            />
                                            <div class="pc-show-recommend-type ellipsis">{{ item.type }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="pc-show-recommend-none-list">
                                相关推荐
                            </div>
                        </div>
                        <div class="pc-show-block-left">
                            <div class="pc-show-block-left-middle">
                                <div class="chat-message-block">
                                    <div class="chat-message-block-logo">
                                        <div v-if="initData.leftName === 2" class="repname"></div>
                                        <img v-else :src="companyLogo" alt="logo" />
                                    </div>
                                    <div class="chat-message-block-text">
                                        <div>
                                            {{ initData.leftName === 2 ? '沈丽佳' : initData.companyName }}
                                        </div>
                                        <div class="chat-message-block-message" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SearchTreeComponent from '../../search-tree-component/index';
import StaffChangeInfoComment from '../../staff-change-info-comment';
import QrcodePoper from '../../qrcode-poper';

const DEFAULT_COMPANY_AVATAR = require('../../../assets/default-company-avatar.png');

export default {
    components: {
        SearchTreeComponent,
        StaffChangeInfoComment,
        QrcodePoper
    },
    props: {
        companyInfoData: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            initData: {
                companyName: '',
                companySignature: '',
                companyAddress: '',
                companyEmail: '',
                companyLogo: '',
                companySite: '',
                companyPhone: '',
                companyIntro: '',
                isSelectCompanySignature: true,
                isSelectCompanyAddress: true,
                isSelectCompanyEmail: true,
                isSelectCompanySite: true,
                isSelectCompanyPhone: true,
                isSelectCompanyIntro: true,
                recommendation: [],
                companyShowCase: 1,
                companyShowCaseImg: [],
                leftName: 1
            },
            disabledIntro: false,
            selectComponent: 'pc',
            default_company_avatar: DEFAULT_COMPANY_AVATAR,
        };
    },
    computed: {
        isRecommendList() {
            const { recommendation } = this.initData;
            return recommendation && recommendation.length > 0;
        },
        isShowCompanyName() {
            const { leftName } = this.initData;
            return leftName === 1;
        },
        isShowStaffName() {
            const { leftName } = this.initData;
            return leftName === 2;
        },
        isOnlyOneImg() {
            return this.initData.companyShowCaseImg.length === 1;
        },
        recommendationData() {
            const { recommendation } = this.initData;
            return recommendation.map(data => {
                return { ...data };
            });
        },
        companyLogo() {
            if (!this.initData.companyLogo || +this.initData.companyLogo === 0) {
                return this.default_company_avatar;
            }
            return this.initData.companyLogo;
        },
    },
    watch: {
        companyInfoData(nextValue) {
            this.initData = nextValue;
            this.$nextTick(() => {
                const dom = this.$refs.companyIntro;
                if (dom) {
                    this.disabledIntro = dom.clientWidth === dom.scrollWidth;
                }
            });
        },
        initData: {
            handler(newData) {
                this.$emit('getNowData', newData, 'companyInfoData');
            },
            deep: true
        }
    },

    methods: {
        visibleChange(val) {
            this.$refs.treeSelect.visibleChange(val);
        },
        listFunction(params, searchKey) {
            params.type = 3;
            const url = searchKey ? '/tp/IMAccessSet/searchBindingOfficial' : '/tp/IMAccessSet/getBindingOfficial';
            return this.$ajax.get(url, {
                params
            });
        },
        saveData() {
            this.$emit('getCompanyInfoData', this.initData);
        },
        updateRecommendList(arrData, map) {
            const resultList = arrData.map(data => {
                return map.get(data);
            });
            this.initData.recommendation = resultList;
        }
    }
};
</script>

<style lang="less">
@import 'style.less';
</style>
